<template>

  <div class="container  d-flex align-items-center justify-content-center" style="width:100%">
    <div class="box-auth" style="width:100vh">
      <div class="box-auth-main">
        <h3 class="auth-box-title mb-20">{{ $t('login') }}</h3>
        <form id="create_form" method="POST" encType="multipart/form-data"
              @submit.prevent="onSubmit">
          <div class="form-group">
            <!-- <label class="lisa-label-input">{{$t("username")}}</label> -->
            <!--<input type="text" class="lisa-input" placeholder="ID / Email / Phone number">-->
            <input type="text" :class="error.field_username?'lisa-input has-err':'lisa-input'"
                   style="margin-bottom: 16px;"
                   name="username"
                   :placeholder="$t('username')"
                   autocomplete="off" v-model="user.username"/>
          </div>
          <div class="form-group">:placeholder
            <!-- <label class="lisa-label-input">{{$t("password_1")}}</label> -->
            <!--<input type="password" id="login-password-field" class="lisa-input has-err"-->
            <!--placeholder="Password">-->
            <!--<span toggle="#login-password-field"-->
            <!--class="icon-eye eye-hide"></span>-->
            <input :type="showPass ? 'text' : 'password'" id="login-password-field" name="password"
                   :class="error.field_password?'lisa-input has-err':'lisa-input'"
                   :placeholder="$t('password')" v-model="user.password"/>
            <span :class="[showPass ? 'icon-eye eye-show' : 'icon-eye eye-hide']"
                  @click="showPass = !showPass"></span>
          </div>
          <div class="form-group">
            <div class="d-flex align-items-center justify-content-between" style="margin-bottom:16px">
              <div class="custom-control custom-switch d-flex align-items-center">
                <input type="checkbox" class="custom-control-input" id="is_student" name="is_student"
                       v-model="is_student">
                <label class="custom-control-label" style="" for="is_student">{{ $t("is_stutdent_login") }}</label>
              </div>
              <a href="/forgot-password" class="forgot-link link-underline">{{ $t("you_ve_forgot_password") }}</a>
            </div>
          </div>
          <div class="form-group" style="margin-bottom: 12px">
            <!--<a href="login1.html" class="lisa-btn-large mb-20">Login</a>-->
            <button type="submit"
                    :class="(user.username != '' && user.password != '') ? 'lisa-btn active mb-28' : 'lisa-btn active mb-28'">
              {{ $t('login') }}
            </button>
            <div class="error-message text-center" style="margin-top: 10px;" v-if="error.message">
              {{ $t(`${error.message}`) }}
            </div>
          </div>
          <!-- <div class="form-group">
              <a href="/register-anomynous" style="color: #fff; background: #FACC5D; width: unset;" class="lisa-btn-large active mb-28">{{ $t('free_trial') }}</a>
              <div class="error-message text-center" v-if="error.message">{{ $t(`${error.message}`) }}</div>
          </div> -->
          <div class="d-flex links" style="margin-top: 50px;">
              <a href="/login" class="link-underline first-link"></a>
              <span style="color: #000; font-size: 14px; text-decoration: none; font-weight: 400;" class="register-link">{{ $t('dont_have_an_account') }}</span>
              <!-- <a @click="choose = !choose" class="link-underline register-link">{{$t('create_new_account')}}</a> -->
              <a href="/register" class="link-underline register-link">{{$t('create_new_account')}}</a>
          </div>

          <!-- <div class="form-group" :class="choose ? 'option-resgiter active' : 'option-resgiter'">
            <label class="lisa-label-input text-center which-you-text">{{ $t("which_is_you") }}</label>
            <select name="choose-type" id="" class="lisa-input" v-model="type">
              <option value="1">{{ $t('parent') }}</option>
              <option value="2">{{ $t('student') }}</option>
            </select>
            <div class="form-group d-flex justify-content-center">
              <div class="btn-next">
                <a :href="type == 1? '/register?type=parent' : '/register?type=student'"
                   class="lisa-btn active">{{ $t("next") }}</a>
              </div>
            </div>
          </div> -->
        </form>
      </div>
      <!-- <div class="dowload-app">
          <h2>{{ $t('dowload_app') }}</h2>
          <p>{{ $t('desc_login') }}</p>
      </div>
      <div class="link-dowload">
          <div>

          </div>
          <div>

          </div>
      </div> -->
      <div class="dowload-app" style="color: #fff;">
        <h2>{{ $t('lisa_web_dowload_app') }}</h2>
        <p>{{ $t('lisa_web_desc_login') }}</p>
        <div class="app-login-download">
          <div class="app-login-android">
            <div style="margin-bottom: 10px">
              <a href="https://play.google.com/store/apps/details?id=ismart.edu.vn.lisa" target="_blank">
                <img src="/themes/ito/images/QR/qr-android.png" class="app-login-qr" alt="">
              </a>
            </div>
            <div>
              <a href="https://play.google.com/store/apps/details?id=ismart.edu.vn.lisa" target="_blank">
                <img src="/themes/ito/images/download-android.svg" alt="">
              </a>
            </div>
          </div>
          <div class="app-login-ios">
            <div style="margin-bottom: 10px">
              <a href="https://apps.apple.com/vn/app/ismart-pro2/id1624442836" target="_blank">
                <img src="/themes/ito/images/QR/qr-ios.png" class="app-login-qr" alt="">
              </a>
            </div>
            <div>
              <a href="https://apps.apple.com/vn/app/ismart-pro2/id1624442836" target="_blank">
                <img src="/themes/ito/images/download-ios.svg" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="chooseAccount" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
         aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header justify-content-center border-0 p-3">
            <h5 class="modal-title" id="staticBackdropLabel">{{ $t('choose_your_account ') }}</h5>
            <div class="close-popup" data-bs-dismiss="modal"></div>
          </div>
          <div class="modal-body p-0" style="margin-left: 10px">
            <div class="form-check" v-for="(student, index) in students" :key="index">
              <input class="form-check-input" v-model="studentId" :value="student.id" type="radio" name="account">
              <label class="form-check-label" for="account1">
                {{ student.username }} _ {{ student.full_name }} {{ student.grade != 0 ? '_' +$t('grade') + ' ' +student.grade :'' }}
              </label>
            </div>

          </div>
          <div class="modal-footer justify-content-center border-0 p-3">
            <button type="button" :disabled="studentId == ''" class="lisa-btn active mb-28" style="width: 50%"
                    @click="onSubmit2()">Login
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {authLogin} from '../../models/auth'
import axios from "axios";
import {getAvatars, getConfig} from "../../models/profile";
import { setTokenData } from '@/APIGateWay';

export default {
  name: "Login",
  data() {
    return {
      error: {
        message: '',
        field_username: '',
        field_password: ''
      },
      students: [],
      studentId: "",
      user: {
        username: '',
        password: ''
      },
      showPass: false,
      choose: false,
      type: 1,
      is_student: true
    };
  },

  created() {
    //this.$store.commit("setLoading", true);

    this.fetch();
    // if (localStorage.getItem('is_login')){
    //     window.location = '/';
    // }
  },

  methods: {
    async fetch() {
      await axios.all([
        getConfig(),
      ]).then(axios.spread((response) => {
        if (response.data.code != 0) {
          return;
        }

        const configs = response.data.results || {};

        localStorage.setItem('configs', JSON.stringify(configs));
      }));
    },
    onSubmit2() {
      let user = this.students.filter(e => e.id == this.studentId)
      const username = user[0].username;
      const password = this.user.password;
      const role_type = this.is_student ? 0 : 1;
      this.login({username, password, role_type});
    },
    onSubmit(e) {
      this.resetErrorsValid();

      if (!this.user.username) {
        this.error.field_username = "Please enter your account.";
        this.error.message = "enter_account";
      }

      if (!this.user.password) {
        this.error.field_password = "Please enter your account.";
        this.error.message = "enter_password";
      }

      if (this.error.message != '') {
        return false;
      }

      const username = this.user.username;
      const password = this.user.password;
      const role_type = this.is_student ? 0 : 1;

      this.login({username, password, role_type});

      e.preventDefault();
    },

    resetErrorsValid() {
      this.error = {
        message: '',
        field_username: '',
        field_password: ''
      }
    },
    login(user) {
      const that = this;
      that.$store.commit("setLoading", true);
      authLogin(user).then((response) => {
        that.$store.commit("setLoading", false);
        if (response.data.code != 0) {
          if (response.data.code == 1) {
            this.error.message = this.$i18n.t(response.data.error_code);
            return false;
          } else {
            this.studentId = "";
            this.students = response.data.student_info;
            $('#chooseAccount').modal("show");

            return false;
          }
        }
        that.$store.commit('setAuth', true);
        that.$store.commit("SET_ROLE_TYPE", that.is_student ? 'student' : 'parent');
        that.$store.commit("SET_CHECK_POPUP", false)
        setTokenData(
            response.data.results.access_token,
            response.data.results.refresh_token,
            response.data.results.expires_in
        )
        // that.$store.commit("SET_FIRST_LOGIN", true)
        localStorage.removeItem('checkedSubjects');

        location.href = '/';
      }).catch(({response}) => {

        this.$store.commit('setAuth', false);
        that.$store.commit("setLoading", false);

        that.error.message = 'An error occurred, please try again later.';
      });
    },
    login2(user) {
      const that = this;

      that.$store.commit("setLoading", true);
      authLogin(user).then((response) => {
        that.$store.commit("setLoading", false);

        if (response.data.code != 0) {
          this.error.message = response.data.error_code;

          return false;
        }

        that.$store.commit('setAuth', true);
        that.$store.commit("SET_ROLE_TYPE", that.is_student ? 'student' : 'parent');
        that.$store.commit("SET_CHECK_POPUP", false)
        // that.$store.commit("SET_FIRST_LOGIN", true)
        localStorage.removeItem('checkedSubjects');
        localStorage.setItem('access_token', response.data.results.access_token);

        location.href = '/';
      }).catch(({response}) => {
        this.$store.commit('setAuth', false);
        that.$store.commit("setLoading", false);

        that.error.message = 'An error occurred, please try again later.';
      });
    }
  }
}
</script>

<style scoped>
.app-login-qr {
  width: 120px;
}

.app-login-download {
  display: flex;
}

.app-login-android, .app-login-ios {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.app-login-ios {
  margin-left: 50px;
}

.dowload-app {
  color: #070A28;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
}

.dowload-app p {
  font-size: 14px;
  width: 400px;
  text-align: center;
}

.form-group {
  position: relative;
}

.lisa-input {
  width: 100%;
}

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

.custom-control-label::before {
  position: absolute;
  top: 0;
  left: -1.5rem;
  display: block;
  width: 23px !important;
  height: 14px;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #adb5bd solid 1px;
}

.custom-control-label::before, .custom-file-label, .custom-select {
  transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}

.custom-control-label::after {
  position: absolute;
  display: block;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.custom-switch .custom-control-label::after {
  top: 2.3px;
  left: calc(-2.25rem + 2px);
  width: 10px;
  height: 10px;
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-transform .15s ease-in-out;
  transition: transform .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  transition: transform .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-transform .15s ease-in-out;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  -webkit-transform: translateX(0.6rem);
  transform: translateX(0.6rem);
}

.custom-control-label {
  color: #000000;
}

.custom-switch {
  width: 50%;
  margin-left: 35px;
}

.lisa-btn {
  width: 100% !important;
  height: 40px;
}

.lisa-input {
  height: 40px;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid rgba(228, 228, 228, 0.6);
  border-radius: 5px;
  padding: 8px 12px;
  margin-bottom: 8px;
  font-size: 14px;;
}

.box-auth-main {
  position: relative;
  width: 580px;
  /* height: 368px; */
  padding: 20px 80px 20px !important;
  background: #ffffff;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
}

.forgot-link {
  text-decoration-line: underline;
  color: #000000;
}

.error-message {
  position: absolute;
  font-size: 14px;
  top: 48px;
  width: 100%;
}

.register-link {
  color: #1F9FFC;
  cursor: pointer;
  text-decoration: underline;
}

.first-link {
  color: #000000;
  font-weight: 400;
}

.option-resgiter {
  -moz-transition: height 0.3s ease;
  -webkit-transition: height 0.3s ease;
  -o-transition: height 0.3s ease;
  transition: height 0.3s ease;
  width: 100%;
  overflow: hidden;
  height: 0;
}

.option-resgiter.active {
  height: 118px;
}

.which-you-text {
  margin: 12px auto 5px !important;
}

.btn-next {
  height: 36px;
  margin: 8px auto;
}

.lisa-btn.active:hover {
  color: #fff;
}

.forgot-link {
  width: unset;
}

.icon-eye {
  top: 42%;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
  font-size: 1rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0px;
  margin-left: -1.25rem;
}

.form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
  color: #212529;

}
.lisa-btn:disabled, .lisa-btn:disabled:hover {
  background: #9e9e9e !important;
  border-color: transparent !important;
  color: white !important;
  cursor: not-allowed !important;
}
</style>
